import React from "react";
import { Container } from "@mantine/core";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import MainContainer from "../../components/MainContainer";
import Setting from "./Setting";
import Notification from "./Notificaton";
import useStyles from "./style";
import { isSubscriptionExpired } from "../../utils";
import { useEffect, useState } from "react";
import SingleTicket from "../SingleTicket/index.jsx";
import HaveProblem from "../HaveProblem/index.jsx";
import NewDashboard from "./Dashboard/NewDashboard.jsx";
import { SkyPointDashboard } from "./Dashboard/SkyPointDashboard.jsx";
import SkyPointNavbar from "../../components/Navbar/SkyPointNavbar.jsx";
import SkypointStaff from "./SkypointStaff/index.jsx";
import SkypointStaffDetails from "./SkypointStaff/SkypointStaffDetails.jsx";
import { SkypointStaffAttendance } from "./SkypointStaff/SkypointStaffAttendance.jsx";
import SkypointBillingInvoices from "./SkypointBillingInvoices/SkypointBillingInvoices.js";
import SkypointProvider from "./SkypointProvider/index.jsx";
import SkypointAddProvider from "./SkypointAddProvider/index.jsx";
import SkypointProviderSettings from "./SkypointProviderSettings/index.jsx";
import ProviderView from "./SkypointProvider/ProviderView.jsx";
import QuarterlyReportsPage from "./QuarterlyReportsPage/index.jsx";
import Prospect from "./Prospect/index.jsx";
import Project from "./Project/index.jsx";
import CriticalAlerts from "./SkypointAlerts/CriticalAlerts.jsx";
import OverdueTasks from "./SkypointAlerts/OverdueTasks.jsx";
import OverdueNotes from "./SkypointAlerts/OverdueNotes.jsx";
import PendingNotes from "./SkypointAlerts/PendingNotes.jsx";
import MissingCarePlans from "./SkypointAlerts/MissingCarePlans.jsx";
import ExpiringDocuments from "./SkypointAlerts/ExpiringDocuments.jsx";
import MarCompletion from "./SkypointAlerts/MarCompletion.jsx";
import DocCompletion from "./SkypointAlerts/DocCompletion.jsx";

const Home = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  let token = Cookies.get("token");
  const { profile } = useSelector((state) => {
    return state?.profile;
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const billing = useSelector((state) => state.featureFlags.billing);
  // const isContractor = profile?.user?.type === "contractor" || profile?.user?.contractor === "contractor";
  // const isContractor =
  //   profile?.user?.type === "contractor" ||
  //   Object.keys(profile?.user || {}).includes("contractor");

  useEffect(() => {
    if (profile?.user?.type === "contractor") {
      navigate("/home/dashboard-skypoint");
    }
  }, [profile?.user?.type]);

  useEffect(() => {
    const isExpired = isSubscriptionExpired();
    if (isExpired) {
      if (profile?.user?.type === "staff") return navigate("/home/settings");
      navigate("/home/settings?selectedTab=upgrade");
    }
  }, [profile?.subscription?.expiredAt]);

  useEffect(() => {
    const isActivated = profile?.signature?.length === 0;
    if (isActivated) {
      if (profile?.user?.type === "staff");
      navigate("/home/settings?selectedTab=my-signature");
    }
  }, [profile?.signature]);

  // when admin reset staff's phone number reset then this useEffect will run
  // useEffect(() => {
  //   const isResetStaff2FA = profile?.user?.isPhoneVerified === false;
  //   if (isResetStaff2FA) {
  //     navigate("/home/settings", { state: { selectedTab: "security", reset2fa: true } } );
  //   }
  // }, [profile]);


  const currentDate = profile?.currentDate ? new Date(profile?.currentDate) : new Date();
  const cutoffDate = new Date("2025-11-30");

  // useEffect(() => {
  //   if (currentDate > cutoffDate && profile?.user?.twoFactorVerified === false) {
  //     navigate("/home/settings", { state: { selectedTab: "security", reset2fa: true } } );
  //   }
  // }, [profile]);

  
  // if (token && !profile?.business && profile?.user?.type === "contractor") {
  //   return <Navigate to="/skypoint-login" />;
  // } else if (token && !profile?.business && profile?.user?.type !== "staff") {
  //   console.log("🚀 ~ Home ~ profile?.business:", profile?.business);
  //   return <Navigate to="/signup" state={{ token: token }} />;
  // }

  const PermissionProtectedRoute = ({ permissionKey, children }) => {
    const permissions = profile?.user?.permissions;

    if (!profile?.user?.role && !profile?.user?.type) {
      return children;
    }

    if (!permissions || !permissions[permissionKey]) {
      return children;
    }
    // if (!permissions || typeof permissions !== "object") {
    //   return children;
    // }

    if (permissions[permissionKey] === true) {
      return children;
    }

    return <Navigate to="/home/dashboard-skypoint" replace />;
  };

  if (!token) return <Navigate to="/skypoint-login" />;

  // if (signatureLoading) return <div>Loading...</div>;

  return (
    <MainContainer isSidebarOpen={isSidebarOpen}>
      <Container className={classes.wrapper} fluid p={0}>
        <SkyPointNavbar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
        {/* {isContractor ? (
          
        ) : (
          null
          // <Nav
          //   isSidebarOpen={isSidebarOpen}
          //   setIsSidebarOpen={setIsSidebarOpen}
          // />
        )} */}
        <Routes>
          <Route
            index
            element={<NewDashboard isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="dashboard-skypoint"
            element={<SkyPointDashboard isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/critical"
            element={<CriticalAlerts isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/overdue-tasks"
            element={<OverdueTasks isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/overdue-notes"
            element={<OverdueNotes isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/pending-notes"
            element={<PendingNotes isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/missing-care-plans"
            element={<MissingCarePlans isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/expiring-documents"
            element={<ExpiringDocuments isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/mar-completion"
            element={<MarCompletion isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="skypoint-alerts/doc-completion"
            element={<DocCompletion isSidebarOpen={isSidebarOpen} />}
          />
          <Route path="staff-skypoint" element={<SkypointStaff />} />
          <Route path="provider-skypoint" element={<SkypointProvider />} />
          <Route
            path="provider-skypoint/:mode"
            element={<SkypointAddProvider />}
          />
          <Route
            path="provider-view"
            element={<ProviderView isSidebarOpen={isSidebarOpen} />}
          />
          <Route
            path="provider-skypoint-settings"
            element={<SkypointProviderSettings />}
          />
          <Route path="report-skypoint" element={<QuarterlyReportsPage />} />

          <Route
            path="staff-skypoint/:id/:mode"
            element={<SkypointStaffDetails />}
          />
          <Route
            path="staff-skypoint/manage-attendance/:id"
            element={<SkypointStaffAttendance />}
          />
          <Route
            path="invoices-skypoint"
            element={<SkypointBillingInvoices />}
          />
          <Route path="prospect" element={<Prospect />} />
          <Route path="project" element={<Project />} />
          {/* <Route path="compliance" element={<CompliancePage />} /> */}
          <Route path="settings" element={<Setting />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="ticket/:id" element={<SingleTicket />} />
          <Route path="create-ticket" element={<HaveProblem />} />
        </Routes>
      </Container>
    </MainContainer>
  );
};
export default Home;
